"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.globalConfig = exports.directionEnum = exports.default = exports.SizeContext = exports.PrefixClsContext = exports.GlobalConfigContext = exports.DirectionContext = exports.ConfigProvider = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var directionEnum;
(function (directionEnum) {
  directionEnum["RTL"] = "RTL";
  directionEnum["rtl"] = "RTL";
  directionEnum["LTR"] = "LTR";
  directionEnum["ltr"] = "LTR";
})(directionEnum || (exports.directionEnum = directionEnum = {}));
var defaultPrefixCls = 'roo';
var DirectionContext = exports.DirectionContext = /*#__PURE__*/React.createContext('LTR');
var PrefixClsContext = exports.PrefixClsContext = /*#__PURE__*/React.createContext(defaultPrefixCls);
var SizeContext = exports.SizeContext = /*#__PURE__*/React.createContext(undefined);
var GlobalConfigContext = exports.GlobalConfigContext = /*#__PURE__*/React.createContext({
  direction: 'LTR',
  prefixCls: defaultPrefixCls
});
var globalHolderRender;
var globalPrefixCls;
var setGlobalConfig = function setGlobalConfig(props) {
  if (props.prefixCls) {
    globalPrefixCls = props.prefixCls;
  }
  if (props.holderRender) {
    globalHolderRender = props.holderRender;
  }
};
// export const ConfigProvider: React.FC<ConfigContextProps> = ({ config, children }) => {
var ConfigProvider = exports.ConfigProvider = function ConfigProvider(_ref) {
  var config = _ref.config,
    children = _ref.children;
  var _a;
  var originDisabled = React.useContext(DirectionContext);
  var originPrefixCls = React.useContext(PrefixClsContext);
  // const size = React.useContext(SizeContext);
  var prefixClsValue = (_a = config === null || config === void 0 ? void 0 : config.prefixCls) !== null && _a !== void 0 ? _a : defaultPrefixCls;
  var directionOnChange = React.useCallback(function () {
    if ((config === null || config === void 0 ? void 0 : config.direction) === 'RTL' || (config === null || config === void 0 ? void 0 : config.direction) === 'rtl') {
      document.documentElement.setAttribute('dir', 'rtl');
      document.documentElement.setAttribute('class', "".concat(prefixClsValue, "-rtl"));
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
      document.documentElement.setAttribute('class', '');
    }
  }, [config === null || config === void 0 ? void 0 : config.direction]);
  React.useEffect(function () {
    directionOnChange();
  }, [config === null || config === void 0 ? void 0 : config.direction]);
  var directionValue = directionEnum[config === null || config === void 0 ? void 0 : config.direction];
  return /*#__PURE__*/React.createElement(GlobalConfigContext.Provider, {
    value: {
      direction: directionValue || originDisabled,
      prefixCls: prefixClsValue || originPrefixCls,
      size: config === null || config === void 0 ? void 0 : config.size
    }
  }, children);
};
var globalConfig = exports.globalConfig = function globalConfig() {
  return {
    prefixCls: globalPrefixCls,
    holderRender: globalHolderRender
  };
};
ConfigProvider.GlobalConfigContext = GlobalConfigContext;
ConfigProvider.config = setGlobalConfig;
var _default = exports.default = ConfigProvider;